import { ALTERAR_TIPO_EMISSAO_PASSAGEIRO_VOLTA } from '../types'

export default function alterarTipoEmissaoPassageiroVolta (passageiro) {
  return {
    type: ALTERAR_TIPO_EMISSAO_PASSAGEIRO_VOLTA,
    payload: passageiro
  }
}
